export const formatAccountDeletionDeadline = (value, locale) => {
    const deadline = new Date(value || "");
    if (Number.isNaN(deadline.getTime())) {
        return null;
    }
    return new Intl.DateTimeFormat(locale || undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short",
    }).format(deadline);
};

export const formatAccountDeletionStatusCheckedAt = (value, locale) => {
    const checkedAt = new Date(value || "");
    if (Number.isNaN(checkedAt.getTime())) {
        return null;
    }
    return new Intl.DateTimeFormat(locale || undefined, {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "short",
    }).format(checkedAt);
};
